import React from 'react';
import { Box, TextField, IconButton, Button } from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';

const ChatInput = ({
  value,
  onChange,
  onSend,
  onKeyDown,
  loading,
  showRetry,
  onRetry,
  disabledSend,
}) => (
  <Box sx={{ p: 1, display: 'flex', flexDirection: 'column', gap: 0.75, bgcolor: 'rgba(11, 18, 32, 0.96)' }}>
    {showRetry && (
      <Button size="small" variant="outlined" onClick={onRetry} disabled={loading} sx={{ alignSelf: 'flex-start' }}>
        Retry last message
      </Button>
    )}
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <TextField
        fullWidth
        size="small"
        placeholder="Ask about your risk score, exposures, or next steps…"
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        disabled={loading}
        multiline
        maxRows={3}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: 3,
            color: '#E6EDF7',
            backgroundColor: 'rgba(22, 35, 58, 0.92)',
            '& fieldset': { borderColor: 'rgba(148, 163, 184, 0.28)' },
            '&:hover fieldset': { borderColor: 'rgba(148, 163, 184, 0.4)' },
            '&.Mui-focused fieldset': { borderColor: '#40D2B7' },
          },
          '& .MuiInputBase-input::placeholder': {
            color: 'rgba(230, 237, 247, 0.6)',
            opacity: 1,
          },
        }}
      />
      <IconButton color="primary" onClick={onSend} disabled={disabledSend} sx={{ flexShrink: 0 }}>
        <SendIcon />
      </IconButton>
    </Box>
  </Box>
);

export default ChatInput;
